export default [
  { label: '0-10 per week', value: '0-10' },
  { label: '10-20 per week', value: '10-20' },
  { label: '20+ per week', value: '20+' }
];
